import { observable } from "mobx";
import { isEmpty } from "../../../utils";
import BaseChannelSettings from "./BaseChannelSettings";

export default class TwilioChannelSettings extends BaseChannelSettings {
    @observable senderPhone: string = '';
    @observable accountSId: string = '';

    constructor(settings?: Partial<TwilioChannelSettings>) {
        super(); // TODO makeObservable
        if (settings) this.update(settings);
    }

    get isValid() {
        return !isEmpty(this.accessToken)
            && !isEmpty(this.senderPhone)
            && !isEmpty(this.accountSId);
    }

    update(entity: Partial<TwilioChannelSettings>, allowUndefined = false) {
        super.update(entity, allowUndefined);
    }

    hasChanges(settings: TwilioChannelSettings) {
        return super.hasChanges(settings)
            || this.senderPhone !== settings.senderPhone
            || this.accountSId !== settings.accountSId;
    }

    clone() {
        return new TwilioChannelSettings(this);
    }
}